import { render, staticRenderFns } from "./choose-many.vue?vue&type=template&id=2e2f55bf&lang=pug&"
import script from "./choose-many.vue?vue&type=script&lang=js&"
export * from "./choose-many.vue?vue&type=script&lang=js&"
import style0 from "./choose-many.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "choose-many.vue"
export default component.exports